<div class="container card p-4 col-12 col-lg-7 ml-0" *transloco="let t; read: TRANSLATION_SCOPE">
  <div class="d-flex justify-content-between">
    <h3>{{ t('header') }}</h3>
    <rx-icon data-qa="test-out-of-office-delete-approver" class="pointer" [name]="'delete'" fill="grey-darker" [size]="'lg'" (click)="deleteClicked()" />
  </div>
  <div class="d-flex no-padding">
    <rx-label-value-card class="col-8 col-lg-4 row" [label]="t('startDate')">
      {{ outOfOfficePeriod().startDateTimeUtc | date: dateFormat() }}
    </rx-label-value-card>
    <rx-label-value-card [label]="t('time')">
      {{ outOfOfficePeriod().startDateTimeUtc | date: regionalTimeFormat() }}
    </rx-label-value-card>
  </div>
  <div class="d-flex">
    <rx-label-value-card class="col-8 col-lg-4 row" [label]="t('endDate')">
      {{ outOfOfficePeriod().endDateTimeUtc | date: dateFormat() }}
    </rx-label-value-card>
    <rx-label-value-card [label]="t('time')">
      {{ outOfOfficePeriod().endDateTimeUtc | date: regionalTimeFormat() }}
    </rx-label-value-card>
  </div>
  <h3 class="mt-4">{{ t('subheader') }}</h3>
  <div class="row no-padding">
    <rx-label-value-card class="col-12 col-lg-6" [label]="t('name')">
      {{ outOfOfficePeriod().fullName }}
    </rx-label-value-card>
    <rx-label-value-card class="col-12 col-lg-6" [label]="t('contactEmail')">
      {{ outOfOfficePeriod().username }}
    </rx-label-value-card>
  </div>
</div>
